(function () {
  'use strict';

  /* ---- Fade-up animations (catalog pages) ---- */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animated = document.querySelectorAll('.luxury-animate');

  if (animated.length) {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      var animObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              animObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );

      animated.forEach(function (el) {
        animObserver.observe(el);
      });
    }
  }

  /* ---- Collection sort ---- */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---- Collection count text ---- */
  var metaEl = document.querySelector('[data-collection-meta]');
  var countEl = document.querySelector('[data-collection-count]');
  if (metaEl && countEl) {
    try {
      var meta = JSON.parse(metaEl.textContent);
    if (meta.total === 0) {
      countEl.textContent = 'No products in this collection';
    } else {
      countEl.textContent = 'Showing ' + meta.from + '–' + meta.to + ' of ' + meta.total + ' products';
    }
    } catch (e) {
      /* ignore */
    }
  }

  /* ---- Mobile filters drawer ---- */
  var filtersPanel = document.querySelector('[data-filters-drawer]');
  var filtersBackdrop = document.querySelector('[data-filters-backdrop]');
  var openBtn = document.querySelector('[data-filters-open]');
  var closeBtn = document.querySelector('[data-filters-close]');

  function openFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.add('is-open');
    if (filtersBackdrop) {
      filtersBackdrop.hidden = false;
      filtersBackdrop.classList.add('is-visible');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.remove('is-open');
    if (filtersBackdrop) {
      filtersBackdrop.classList.remove('is-visible');
      filtersBackdrop.hidden = true;
    }
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openFilters);
  if (closeBtn) closeBtn.addEventListener('click', closeFilters);
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFilters);

  /* Real Shopify filter checkboxes */
  document.querySelectorAll('[data-filter-url]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.dataset.filterUrl) {
        window.location.href = input.dataset.filterUrl;
      }
    });
  });

  /* Dummy filter toggles */
  document.querySelectorAll('[data-dummy-filter]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.type === 'range') return;
      e.preventDefault();
      if (el.classList.contains('luxury-filter-swatch') || el.classList.contains('luxury-filter-size')) {
        el.parentElement.querySelectorAll('.is-active').forEach(function (s) {
          s.classList.remove('is-active');
        });
        el.classList.add('is-active');
      }
    });
  });

  /* ---- Product gallery ---- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var images = gallery.querySelectorAll('[data-gallery-image]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.galleryThumb;
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.index === index);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* ---- Quantity selector ---- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');

    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ---- Variant selection ---- */
  var productForm = document.querySelector('[data-product-form]');
  var variantsJson = document.querySelector('[data-product-variants]');

  if (productForm && variantsJson) {
    var variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      variants = [];
    }

    var selectedOptions = [];
    productForm.querySelectorAll('.luxury-variant-pill.is-active, .luxury-variant-swatch.is-active').forEach(function (btn, i) {
      selectedOptions[i] = btn.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return !selectedOptions[i] || opt === selectedOptions[i];
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariantUI(variant) {
      if (!variant) return;
      var idInput = productForm.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var skuEl = document.querySelector('[data-product-sku]');
      var addBtn = productForm.querySelector('[data-add-to-cart]');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else if (compareEl) {
        compareEl.hidden = true;
      }
      if (skuEl) skuEl.textContent = variant.sku || 'N/A';
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    productForm.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.luxury-variant-pills, .luxury-variant-swatches');
        if (group) {
          group.querySelectorAll('.is-active').forEach(function (b) {
            b.classList.remove('is-active');
          });
        }
        btn.classList.add('is-active');
        selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
        var variant = findVariant();
        updateVariantUI(variant);
      });
    });
  }

  /* ---- Buy Now ---- */
  var buyNowBtn = document.querySelector('[data-buy-now]');
  if (buyNowBtn && productForm) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var idInput = productForm.querySelector('[data-variant-id]');
      var qtyInput = productForm.querySelector('[data-qty-input]');
      if (!idInput) return;
      var qty = qtyInput ? qtyInput.value : 1;
      window.location.href = '/cart/' + idInput.value + ':' + qty;
    });
  }

  /* ---- Recently viewed (localStorage) ---- */
  var STORAGE_KEY = 'luxury_recently_viewed';
  var MAX_ITEMS = 8;
  var productSection = document.querySelector('[data-product-id]');

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewed(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore */
    }
  }

  if (productSection) {
    var current = {
      id: productSection.dataset.productId,
      handle: productSection.dataset.productHandle,
      title: productSection.dataset.productTitle,
      url: productSection.dataset.productUrl,
      image: productSection.dataset.productImage,
      price: productSection.dataset.productPrice
    };

    var items = getRecentlyViewed().filter(function (item) {
      return String(item.id) !== String(current.id);
    });
    items.unshift(current);
    items = items.slice(0, MAX_ITEMS);
    saveRecentlyViewed(items);
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed]');
    var list = document.querySelector('[data-recently-viewed-list]');
    if (!section || !list) return;

    var items = getRecentlyViewed();
    var excludeId = productSection ? productSection.dataset.productId : null;

    items = items.filter(function (item) {
      return !excludeId || String(item.id) !== String(excludeId);
    });

    if (items.length === 0) {
      section.hidden = true;
      return;
    }

    section.hidden = false;
    list.innerHTML = items
      .map(function (item) {
        return (
          '<a class="luxury-recently-viewed__item" href="' +
          item.url +
          '">' +
          '<img src="' +
          item.image +
          '" alt="' +
          (item.title || '') +
          '" loading="lazy" width="160" height="200">' +
          '<p class="luxury-recently-viewed__item-title">' +
          (item.title || '') +
          '</p>' +
          '<p class="luxury-recently-viewed__item-price">' +
          (item.price || '') +
          '</p>' +
          '</a>'
        );
      })
      .join('');
  }

  renderRecentlyViewed();

  var clearBtn = document.querySelector('[data-recently-viewed-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      localStorage.removeItem(STORAGE_KEY);
      renderRecentlyViewed();
    });
  }
})();
